module.exports = __webpack_public_path__ + "media/St 4-computer-hint.f06384d6.wav";